
export { Heading } from "./Heading"